__turbopack_context__.v({
  "bg": "MAymCa_bg",
  "content": "MAymCa_content",
  "description": "MAymCa_description",
  "featureCard": "MAymCa_featureCard",
  "features": "MAymCa_features",
  "full-size": "MAymCa_full-size",
  "img-wrapper": "MAymCa_img-wrapper",
  "root": "MAymCa_root",
  "video": "MAymCa_video",
  "video-content": "MAymCa_video-content",
  "videoRoot": "MAymCa_videoRoot",
});
